<template>
  <div class="location">
    <table>
      <thead>
        <tr>
          <td><b class="mini-font">SPBU NAME</b></td>
          <td><b class="mini-font">TRAFFIC</b></td>
        </tr>
      </thead>
      <tbody v-if="locations">
        <tr v-for="(item, index) in locations.location_set" :key="index">
          <td><span class="subhead">{{item.location.title}}</span></td>
          <td><span class="subhead">{{item.get_traffic | formatNumber}}</span></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import api from '@/api'
import { apiV2 } from '@/api/urls'
import moment from 'moment'
import _ from 'lodash'
import { nextTick } from 'q'

export default {
  name: 'adx-dashboard-campaignreport-location',
  components: {

  },
  props: {
    data: {
      required: false
    }
  },
  data() {
    return {
      locations: null
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {
    
  },
  beforeMount() {

  },
  mounted() {
    this.$nextTick(function() {
      this.locations = this.$parent._data.dataMeasurement
    })
  },
  beforeUpdate() {

  },
  updated() {
    
  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
